export default {
	data() {
		return {
			submitError: ""
		}
	},
	methods: {
		handleSubmitError(err) {
			this.submitError = err.response.data.msg
			return err.response.data
		}
	}
}
